import type { FaireProductEntity } from "../../entity_types/product";

export const p_9f9be7smkt: FaireProductEntity = {
  token: "p_9f9be7smkt",
  type: "product",
  name: "Copper Healing Cube",
  brandToken: "b_92q2hhsl",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e0f841b1811ce2ad56f6cec6d9a4b30a11c170c1c8f741ff9bfb2d814152ea41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fdd33c25075f87819821afaa9d3c554cfd5ffe944a9f3cedd8e2fd638ae6f99c.jpeg",
    "https://cdn.faire.com/fastly/468bbd02b4110b4347090289f20bb0ce505699642fe1d9570cd1be4dce033f9a.jpeg",
  ],
  priceDollars: 48,
  description:
    "\n Get solid and grounded with the Copper Healing Cube. Taking divine inspiration from one of the most supportive and pure shapes in sacred geometry, this copper cube is all about staying strong and conducting the kind of energy you need. Copper is one of the worlds most powerful conductors and is here to bring an anchor of inner wisdom, balanced emotions, and shimmering shades of self-respect.\n\n“With this cube, I anchor to the ground and connect with all the sacred patterns of the universe”\n\nDescription\n\nEver ready to anchor, this Copper Healing Cube is solid from every angle. Four sides are beautifully harmonized and immortalized in singing copper, reminding us of the magic of the Archangel Metatron who oversees the flow of energy and the meaning of life within the mystical cube.",
  tags: [],
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:04.479Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
